var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "kompa-smoke-sensors-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('checkbox', {
    ref: "indoor",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.indoor,
      "label": _vm.$t('fields.indoor')
    },
    model: {
      value: (_vm.form.model.indoor),
      callback: function($$v) {
        _vm.form.model.indoor = $$v
      },
      expression: "form.model.indoor"
    }
  }), _vm._v(" "), _c('checkbox', {
    ref: "outdoor",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.outdoor,
      "label": _vm.$t('fields.outdoor')
    },
    model: {
      value: (_vm.form.model.outdoor),
      callback: function($$v) {
        _vm.form.model.outdoor = $$v
      },
      expression: "form.model.outdoor"
    }
  }), _vm._v(" "), _c('checkbox', {
    ref: "powerCord",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.powerCord,
      "label": _vm.$t('fields.powerCord')
    },
    model: {
      value: (_vm.form.model.powerCord),
      callback: function($$v) {
        _vm.form.model.powerCord = $$v
      },
      expression: "form.model.powerCord"
    }
  }), _vm._v(" "), _c('checkbox', {
    ref: "batteryPowered",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.batteryPowered,
      "label": _vm.$t('fields.batteryPowered')
    },
    model: {
      value: (_vm.form.model.batteryPowered),
      callback: function($$v) {
        _vm.form.model.batteryPowered = $$v
      },
      expression: "form.model.batteryPowered"
    }
  }), _vm._v(" "), _c('checkbox', {
    ref: "reachEnhencer",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.reachEnhencer,
      "label": _vm.$t('fields.reachEnhencer')
    },
    model: {
      value: (_vm.form.model.reachEnhencer),
      callback: function($$v) {
        _vm.form.model.reachEnhencer = $$v
      },
      expression: "form.model.reachEnhencer"
    }
  }), _vm._v(" "), _c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe86d646","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/KompaSmokeSensorsForm.vue
// module id = 2151
// module chunks = 0